import { FileKeyFacilitationService } from '@/services/abstract/FileKeyFacilitationService';
import type { FetcherService } from '@/services/abstract/FetcherService';
import type { MissingFileKeyHelpRequest } from '@/types/fileKey/FileKeyFacilitation';
import { sixEndpoints } from '@/api/endpoints';

import { mockMissingFileKeysResponse } from './mockMissingFileKeys';

// eslint-disable-next-line prefer-const -- toggled during development
let USE_MOCK = false;

export class FileKeyFacilitationServiceImpl extends FileKeyFacilitationService {
  constructor(private readonly fetcher: FetcherService) {
    super();
  }

  async getMissingFileKeyRequests(): Promise<MissingFileKeyHelpRequest[]> {
    if (USE_MOCK) {
      return mockMissingFileKeysResponse.missingFileKeyHelpRequest;
    }

    try {
      return await this.fetcher.get<MissingFileKeyHelpRequest[]>(
        sixEndpoints.getMissingFileKeys
      );
    } catch (error) {
      if (error instanceof Error && error.message.includes('404')) {
        return [];
      }
      throw error;
    }
  }
}
